import { Box, InputLabel } from "@mui/material";
import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme

    [{ align: [] }],

    ["clean"],
  ],
};
function RichTextEditor({
  value,
  handleChange,
  name,
  title,
  placeholder,
  readOnly = false,
}) {
  const onChange = (e) => {
    handleChange({ target: { name, value: e } });
  };

  return (
    <Box sx={{ width: "100%" }}>
      {title && (
        <InputLabel
          sx={{
            mb: 1,
            fontWeight: "700",
            lineHeight: "18px",
            color: "primary.formLabel",
            fontSize: "0.86rem",
            position: "relative",
            width: "fit-content",

            textTransform: "capitalize",
          }}
          htmlFor={name}
        >
          {title}
        </InputLabel>
      )}
      <ReactQuill
        theme="snow"
        value={value}
        {...(handleChange && { onChange })}
        modules={readOnly ? { toolbar: [] } : modules}
        id={name}
        placeholder={placeholder}
        readOnly={readOnly}
        {...(readOnly && { className: "read-only" })}
      />
    </Box>
  );
}
export default RichTextEditor;
